import React from "react";
import { useNavigate } from "react-router-dom";
import { createBookingType } from "adminApi/RoomBookingTypeListsApi/RoomBookingTypeLists";
import { BookingTypeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { validateForm } from "utils/validation";
import fields from "../json/BookingTypeListFields.json";
import AddBookingForm from "./AddBookingForm";

const AddBookingType = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    // Build initial values from field definitions
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors } = useFormChange(initialValues, BookingTypeRules);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        // Send plain JSON — no file uploads in this form
        async (formValues) => await createBookingType({ data: formValues }),
        (vals) => {
            const err = validateForm(vals, BookingTypeRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Booking Type Created Successfully"
    );

    return (
        <>
            {loadingSubmit && <Spinner isSpinner={true} />}
            <AddBookingForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Add Booking Type"
            />
        </>
    );
};

export default AddBookingType;
